import { Customer, CustomerInfo, PracticeInfo } from '.';

export class AccountDetails {
  customer: Customer = new Customer();
  customerInfo: CustomerInfo = new CustomerInfo();
  practiceInfo: PracticeInfo = new PracticeInfo();
}

export class PayNowPracticeAccountDetails {
  customer: Customer = new Customer();
  customerInfo: CustomerInfo = new CustomerInfo();
  practiceInfo: PracticeInfo = new PracticeInfo();
  payNowCorrelationId: string
}

export class UpdateAccountDetailsCommand {
  updateCustomerInfo: CustomerInfo = new CustomerInfo();
  updatePracticeInfo: PracticeInfo = new PracticeInfo();
}
